"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useWindowSize = _interopRequireDefault(require("react-use/lib/useWindowSize"));

var _useBrowser = _interopRequireDefault(require("@arcblock/react-hooks/lib/useBrowser"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@arcblock/ux/lib/Button"));

var _basic = _interopRequireDefault(require("./basic"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable react/jsx-one-expression-per-line */


var noop = function noop() {};

var iosLink = 'https://itunes.apple.com/app/id1460083542';
var androidLink = 'https://play.google.com/store/apps/details?id=com.arcblock.wallet.app.product';
var translations = {
  en: {
    or: 'or',
    signup: {
      title: 'Sign Up',
      description: 'Download ABT Wallet and signup with your preferred profile.',
      downloadIOS: 'Download iOS',
      downloadAndroid: 'Download Android',
      more: 'Learn more about ABT Wallet',
      here: 'here'
    }
  },
  zh: {
    or: '或',
    signup: {
      title: '注册',
      description: '下载 ABT 钱包然后在里面创建钱包和个人档案',
      downloadIOS: '下载 iOS 版本',
      downloadAndroid: '下载 Android 版本',
      more: '想了解更多钱包介绍？猛击',
      here: '这里'
    }
  }
};

function BasicWithSignup(_ref) {
  var theme = _ref.theme,
      locale = _ref.locale,
      action = _ref.action,
      prefix = _ref.prefix,
      socketUrl = _ref.socketUrl,
      checkFn = _ref.checkFn,
      messages = _ref.messages,
      extraParams = _ref.extraParams,
      checkInterval = _ref.checkInterval,
      checkTimeout = _ref.checkTimeout,
      onError = _ref.onError,
      onClose = _ref.onClose,
      onSuccess = _ref.onSuccess,
      disableClose = _ref.disableClose,
      responsive = _ref.responsive;

  var _ref2 = (0, _useWindowSize["default"])(),
      width = _ref2.width;

  var translation = translations[locale] || translations.en;
  var browser = (0, _useBrowser["default"])();

  var content = _react["default"].createElement(Container, null, !disableClose && _react["default"].createElement("div", {
    className: "auth-close",
    onClick: onClose
  }, "\xD7"), _react["default"].createElement("div", {
    className: "left"
  }, _react["default"].createElement(_basic["default"], {
    className: "auth-wrapper",
    locale: locale,
    action: action,
    prefix: prefix,
    socketUrl: socketUrl,
    qrcodeSize: 160,
    checkFn: checkFn,
    messages: messages,
    extraParams: extraParams,
    checkInterval: checkInterval,
    checkTimeout: checkTimeout,
    onError: onError,
    onSuccess: onSuccess,
    disableClose: true,
    showDownload: false
  })), _react["default"].createElement("div", {
    className: "separator"
  }, _react["default"].createElement("div", {
    className: "separator-top"
  }), _react["default"].createElement("div", {
    className: "separator-text"
  }, translation.or), _react["default"].createElement("div", {
    className: "separator-top"
  })), _react["default"].createElement("div", {
    className: "signup"
  }, _react["default"].createElement(_Typography["default"], {
    component: "h3",
    className: "signup-title"
  }, translation.signup.title), _react["default"].createElement(_Typography["default"], {
    component: "p",
    className: "signup-description"
  }, translation.signup.description), !browser.mobile.any && _react["default"].createElement("div", {
    className: "signup-buttons"
  }, _react["default"].createElement(_Button["default"], {
    href: iosLink,
    target: "_blank",
    variant: "outlined",
    color: "primary",
    size: "large",
    className: "signup-button"
  }, translation.signup.downloadIOS), _react["default"].createElement(_Button["default"], {
    href: androidLink,
    variant: "outlined",
    target: "_blank",
    color: "primary",
    size: "large",
    className: "signup-button"
  }, translation.signup.downloadAndroid)), (browser.mobile.android.phone || browser.mobile.android.tablet) && _react["default"].createElement("div", {
    className: "signup-buttons"
  }, _react["default"].createElement(_Button["default"], {
    href: androidLink,
    variant: "outlined",
    target: "_blank",
    color: "primary",
    size: "large",
    className: "signup-button"
  }, translation.signup.downloadAndroid)), (browser.mobile.apple.phone || browser.mobile.apple.tablet) && _react["default"].createElement("div", {
    className: "signup-buttons"
  }, _react["default"].createElement(_Button["default"], {
    href: iosLink,
    target: "_blank",
    variant: "outlined",
    color: "primary",
    size: "large",
    className: "signup-button"
  }, translation.signup.downloadIOS)), _react["default"].createElement(_Typography["default"], {
    component: "p",
    className: "signup-tip"
  }, translation.signup.more, ' ', _react["default"].createElement("a", {
    href: "https://abtwallet.io",
    target: "_blank",
    rel: "noopener noreferrer"
  }, translation.signup.here))));

  if (browser.wallet) {
    content = _react["default"].createElement(Container, {
      wallet: true
    }, !disableClose && _react["default"].createElement("div", {
      className: "auth-close",
      onClick: onClose
    }, "\xD7"), _react["default"].createElement(_basic["default"], {
      className: "auth-wrapper",
      locale: locale,
      action: action,
      prefix: prefix,
      socketUrl: socketUrl,
      qrcodeSize: 160,
      checkFn: checkFn,
      messages: messages,
      extraParams: extraParams,
      checkInterval: checkInterval,
      checkTimeout: checkTimeout,
      onError: onError,
      onSuccess: onSuccess,
      disableClose: true,
      showDownload: false
    }));
  }

  if (responsive) {
    return _react["default"].createElement(_Dialog["default"], {
      open: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      maxWidth: "lg",
      fullScreen: width < theme.breakpoints.values.sm && !browser.wallet
    }, _react["default"].createElement(_DialogContent["default"], {
      style: {
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, content));
  }

  return content;
}

BasicWithSignup.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  onError: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  responsive: _propTypes["default"].bool,
  disableClose: _propTypes["default"].bool,
  onSuccess: _propTypes["default"].func.isRequired,
  action: _propTypes["default"].string.isRequired,
  checkFn: _propTypes["default"].func.isRequired,
  locale: _propTypes["default"].oneOf(['en', 'zh']),
  prefix: _propTypes["default"].string,
  socketUrl: _propTypes["default"].string,
  checkInterval: _propTypes["default"].number,
  checkTimeout: _propTypes["default"].number,
  extraParams: _propTypes["default"].object,
  messages: _propTypes["default"].object
};
BasicWithSignup.defaultProps = {
  locale: 'en',
  prefix: '/api/did',
  socketUrl: '',
  onError: noop,
  onClose: noop,
  responsive: true,
  disableClose: false,
  checkInterval: 2000,
  checkTimeout: 60000,
  // 1 minute
  extraParams: {},
  messages: {}
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "WithSignup__Container",
  componentId: "sc-1cp3aq-0"
})(["display:flex;flex-direction:row;justify-content:center;align-items:flex-start;", " padding:40px;position:relative;box-sizing:border-box;.auth-close{position:absolute;top:1rem;right:1rem;color:#222222;font-size:2rem;line-height:1rem;cursor:pointer;user-select:none;}.left{flex:1;width:220px;.auth-wrapper{padding:0;width:100%;}.auth-qrcode{margin-top:1rem;}}.separator{width:120px;height:100%;display:flex;flex-direction:column;justify-content:space-between;align-items:center;.separator-top,.separator-bottom{width:1px;height:40%;background:#999;}.separator-text{text-align:center;text-transform:uppercase;}}.auth-title,.signup-title{font-size:24px;font-weight:300;color:#222222;margin-bottom:1rem;}.auth-tip,.signup-description{font-size:14px;line-height:1.4;color:#222222;}.signup{flex:1;width:220px;.signup-description{margin:1.2rem 0 2.4rem;}.signup-buttons{margin-bottom:2.4rem;.signup-button{display:block;margin-bottom:1rem;text-align:center;}}.signup-tip{font-size:14px;line-height:1.6;color:#9b9b9b;}}@media (max-width:768px){flex-direction:column;width:auto;height:auto;padding:32px;.separator{width:100%;height:80px;flex-direction:row;.separator-top,.separator-bottom{height:1px;width:40%;}}}"], function (props) {
  return props.wallet ? '' : 'width: 640px; height: 372px;';
});

var _default = (0, _styles.withTheme)(BasicWithSignup);

exports["default"] = _default;